import { render, staticRenderFns } from "./ServiceLogForm.vue?vue&type=template&id=ef56f8dc&scoped=true"
import script from "./ServiceLogForm.vue?vue&type=script&lang=js"
export * from "./ServiceLogForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceLogForm.vue?vue&type=style&index=0&id=ef56f8dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef56f8dc",
  null
  
)

export default component.exports